import * as React from "react";
import { Base } from "ui/Scripts/source/framework/base";
import { EnumHelper, TaskDataRowDataType } from "ui/Scripts/source/models/enums";
import { ITaskDataRowCol } from "ui/Scripts/source/models/task/taskDataRowCol";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";
import { TaskDynamicFormLabel } from "./TaskDynamicFormLabel";
import { TaskDynamicFormString } from "./TaskDynamicFormString";
import { TaskDynamicFormNumber } from "./TaskDynamicFormNumber";
import { TaskDynamicFormInteger } from "./TaskDynamicFormInteger";
import { TaskDynamicFormDate } from "./TaskDynamicFormDate";
import { TaskDynamicFormTime } from "./TaskDynamicFormTime";
import { TaskDynamicFormTimeSpan } from "./TaskDynamicFormTimeSpan";
import { TaskDynamicFormBoolean } from "./TaskDynamicFormBoolean";
import { TaskDynamicFormStringArray } from "./TaskDynamicFormStringArray";
import { TaskDynamicFormTreeStringArray } from "./TaskDynamicFormTreeStringArray";
import { TaskDynamicFormLineBreak } from "./TaskDynamicFormLineBreak";
import { TaskDynamicFormSignature } from "./TaskDynamicFormSignature";
import { TaskDynamicFormPageBreak } from "./TaskDynamicFormPageBreak";
import { TaskDynamicFormTitlePage } from "./TaskDynamicFormTitlePage";
import { TaskDynamicFormRichText } from "./TaskDynamicFormRichText";
import { TaskDynamicFormDocumentReference } from "./TaskDynamicFormDocumentReference";
import { TaskDynamicFormEventReference } from "./TaskDynamicFormEventReference";
import { TaskDynamicFormTaskReference } from "./TaskDynamicFormTaskReference";
import { TaskDynamicFormRecordReference } from "./TaskDynamicFormRecordReference";

export interface ITaskDynamicFormColProp {
    isReadOnly: boolean;
    colIsReadOnly: boolean;
    showFieldName?: boolean;
    showFieldNameColor?: string;
    taskTypeCol: ITaskTypeCol;
    taskDataRowCol: ITaskDataRowCol;
    taskDataRowColOrg?: ITaskDataRowCol;
    ignoreClass?: boolean;
    isEdit?: boolean;
    onChange: (dataCol: ITaskDataRowCol) => void;
}

export class TaskDynamicFormCol extends React.Component<ITaskDynamicFormColProp, {}> {
    render() {
        const props = this.props;
        const col = props.taskTypeCol;
        let element = null;
        if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.Label)) {
            element =
                <TaskDynamicFormLabel
                    taskTypeCol={col}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.String)) {
            element =
                <TaskDynamicFormString
                    isReadOnly={props.isReadOnly}
                    colIsReadOnly={props.colIsReadOnly}
                    showFieldName={props.showFieldName}
                    showFieldNameColor={props.showFieldNameColor}
                    taskTypeCol={col}
                    taskDataRowCol={props.taskDataRowCol}
                    onChange={props.onChange}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.Number)) {
            element =
                <TaskDynamicFormNumber
                    isReadOnly={props.isReadOnly}
                    colIsReadOnly={props.colIsReadOnly}
                    showFieldName={props.showFieldName}
                    showFieldNameColor={props.showFieldNameColor}
                    taskTypeCol={col}
                    taskDataRowCol={props.taskDataRowCol}
                    onChange={props.onChange}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.Integer)) {
            element =
                <TaskDynamicFormInteger
                    isReadOnly={props.isReadOnly}
                    colIsReadOnly={props.colIsReadOnly}
                    showFieldName={props.showFieldName}
                    showFieldNameColor={props.showFieldNameColor}
                    taskTypeCol={col}
                    taskDataRowCol={props.taskDataRowCol}
                    onChange={props.onChange}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.Date)) {
            element =
                <TaskDynamicFormDate
                    isReadOnly={props.isReadOnly}
                    colIsReadOnly={props.colIsReadOnly}
                    showFieldName={props.showFieldName}
                    showFieldNameColor={props.showFieldNameColor}
                    taskTypeCol={col}
                    taskDataRowCol={props.taskDataRowCol}
                    onChange={props.onChange}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.Time)) {
            element =
                <TaskDynamicFormTime
                    isReadOnly={props.isReadOnly}
                    colIsReadOnly={props.colIsReadOnly}
                    showFieldName={props.showFieldName}
                    showFieldNameColor={props.showFieldNameColor}
                    taskTypeCol={col}
                    taskDataRowCol={props.taskDataRowCol}
                    onChange={props.onChange}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.TimeSpan)) {
            element =
                <TaskDynamicFormTimeSpan
                    isReadOnly={props.isReadOnly}
                    colIsReadOnly={props.colIsReadOnly}
                    showFieldName={props.showFieldName}
                    showFieldNameColor={props.showFieldNameColor}
                    taskTypeCol={col}
                    taskDataRowCol={props.taskDataRowCol}
                    onChange={props.onChange}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.Boolean)) {
            element =
                <TaskDynamicFormBoolean
                    isReadOnly={props.isReadOnly}
                    colIsReadOnly={props.colIsReadOnly}
                    showFieldName={props.showFieldName}
                    showFieldNameColor={props.showFieldNameColor}
                    taskTypeCol={col}
                    taskDataRowCol={props.taskDataRowCol}
                    onChange={props.onChange}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.StringArray)) {
            element =
                <TaskDynamicFormStringArray
                    isReadOnly={props.isReadOnly}
                    colIsReadOnly={props.colIsReadOnly}
                    showFieldName={props.showFieldName}
                    showFieldNameColor={props.showFieldNameColor}
                    taskTypeCol={col}
                    taskDataRowCol={props.taskDataRowCol}
                    selectSubSectionValuesByTitle={col.selectOptionsSubSectionValuesByTitle}
                    onChange={props.onChange}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.TreeStringArray)) {
            element =
                <TaskDynamicFormTreeStringArray
                    isReadOnly={props.isReadOnly}
                    colIsReadOnly={props.colIsReadOnly}
                    showFieldName={props.showFieldName}
                    showFieldNameColor={props.showFieldNameColor}
                    taskTypeCol={col}
                    taskDataRowCol={props.taskDataRowCol}
                    onChange={props.onChange}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.Signature)) {
            element =
                <TaskDynamicFormSignature
                    isReadOnly={props.isReadOnly || !!props.isEdit && !!props.taskDataRowColOrg?.valueStr}
                    colIsReadOnly={props.colIsReadOnly}
                    taskTypeCol={col}
                    taskDataRowCol={props.taskDataRowCol}
                    onChange={props.onChange}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.LineBreak)) {
            element =
                <TaskDynamicFormLineBreak
                    taskTypeCol={col}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.PageBreak)) {
            element =
                <TaskDynamicFormPageBreak
                    taskTypeCol={col}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.TitlePage)) {
            element =
                <TaskDynamicFormTitlePage
                    taskTypeCol={col}
                    taskDataRowCol={props.taskDataRowCol}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.RichText)) {
            element =
                <TaskDynamicFormRichText
                    taskTypeCol={col}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.DocumentReference)) {
            element =
                <TaskDynamicFormDocumentReference
                    taskTypeCol={col}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.EventReference)) {
            element =
                <TaskDynamicFormEventReference
                    taskTypeCol={col}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.TaskReference)) {
            element =
                <TaskDynamicFormTaskReference
                    taskTypeCol={col}
                />;
        } else if (EnumHelper.isEqual(col.dataType, TaskDataRowDataType.RecordReference)) {
            element =
                <TaskDynamicFormRecordReference
                    taskTypeCol={col}
                />;
        }
        return (
            !props.ignoreClass
                ? <div className={"col " + (!Base.isNullOrEmpty(col.class) ? col.class : "")}>
                    {element}
                </div>
                : element
        );
    }
}